import { render, staticRenderFns } from "./AssessmentScreen.vue?vue&type=template&id=8daa983c&scoped=true&"
import script from "./AssessmentScreen.vue?vue&type=script&lang=js&"
export * from "./AssessmentScreen.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentScreen.vue?vue&type=style&index=0&id=8daa983c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8daa983c",
  null
  
)

export default component.exports